import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/kr1tAmQu43YLunWY8i225F/ChatGPT-Image-8-jul-2026_-09_50_12-p.m..webp';
export function Hero() {
  return <section className="pt-8 pb-6 px-4 sm:px-6 bg-white text-center border-b-4 border-brand-ivory" data-id="element-91">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-violet/10 border border-brand-violet/20 text-brand-navy font-heading font-bold text-xs sm:text-sm mb-4" data-id="element-92">
        <span data-id="element-93">🤸</span>
        <span className="tracking-wide uppercase" data-id="element-94">
          Per Allenatori di Ginnastica Artistica
        </span>
      </div>

      <h1 className="text-2xl sm:text-4xl font-heading font-extrabold text-brand-navy leading-tight mb-3" data-id="element-95">
        Il Sistema Completo di Pianificazione per Allenatori di Ginnastica
        Artistica
      </h1>

      <p className="text-base sm:text-lg text-brand-text font-medium leading-relaxed mb-5 max-w-xl mx-auto" data-id="element-96">
        Risparmia ore ogni settimana preparando allenamenti, esercizi,
        progressioni tecniche e programmazioni stagionali, senza dover creare
        ogni lezione da zero.
      </p>

      <div className="mb-5" data-id="element-97">
        <a href="#pricing" className="block cursor-pointer" data-id="element-98">
          <img src={PRODUCT_IMG} alt="GINNASTICA PRO - Sistema Completo 6-in-1" className="w-full h-auto object-contain max-w-[380px] sm:max-w-md mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-99" />
        </a>
      </div>

      <div className="mb-4" data-id="element-100">
        <CTAButton href="#pricing" data-id="element-101">🚀 SÌ! VOGLIO IL MIO SISTEMA ORA</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm text-brand-text font-bold" data-id="element-102">
        <div className="flex items-center gap-1.5" data-id="element-103">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-104" />
          <span data-id="element-105">4.9/5 — Recensioni Verificate dagli Allenatori</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-106">
          <Shield className="w-4 h-4 text-brand-violet" data-id="element-107" />
          <span data-id="element-108">Garanzia 14 Giorni — Zero Rischi</span>
        </div>
      </div>
    </section>;
}